import React, { useEffect, useRef, useState } from 'react';
import { Modal, Form, Button } from 'react-bootstrap';
import { Formik } from 'formik';
import * as yup from 'yup';
import { setLocale } from 'yup';
import { ICON_SAVE, ICON_CANCEL, ICON_SEARCH, ICON_REMOVE } from '../../../../extras/icons';
import ButtonSpinner from '../../../../layout/ButtonSpinner';
//Redux
import { useDispatch } from 'react-redux';
import { updateAccusedAction } from '../../../../../actions/audiencesActions';
//Axios
import clienteAxios from '../../../../../config/axios';

import LawyerSearchForm from '../../../LawyerSearchForm';

//Función principal
const AccusedDefenseEditForm = props => {
    //Tomo los props
    const { show, handleClose, audience, accused } = props;
    //Genero los ref
    const refMenor = useRef();
    //Inicializo datos
    const initialData = {
        menor: accused.menor ? accused.menor : 0,
        menores: accused.menores ? accused.menores.id : '',
        defensoria: accused.defensoria ? accused.defensoria.id : ''
    }
    //Inicializo el dispatch
    const dispatch = useDispatch();
    //Inicializo el state local
    const [ loading, setLoading ] = useState(false);
    const [ minors, setMinors ] = useState([]);
    const [ defensories, setDefensories ] = useState([]);
    const [ showLawyer, setShowLawyer ] = useState(false);
    const [ particulars, setParticulars ] = useState([]);
    const [ hide, setHide ] = useState(false);
    //Al inicio
    useEffect(() => {
        //Seteo abogados
        setParticulars(accused.imputadoParticularesList);
    }, []);
    //Manejo cuando se muestra
    const handleOnShow = async e => {
        //Cargo espera
        setLoading(true);
        //Cargo las defensorías de menores
        const responseMinors = await clienteAxios.get(`/defensoria?search=menor:1,activo:1&sort=descripcion:asc`);
        setMinors(responseMinors.data.content);
        //Cargo las defensorías
        const responseDefensories = await clienteAxios.get(`/defensoria?search=menor:0,activo:1&sort=descripcion:asc`);
        setDefensories(responseDefensories.data.content);
        //Oculto la espera
        setLoading(false);
        //Pongo el foco en el primer campo
        refMenor.current.focus();
    }
    //Manejo el guardado
    const handleSave = values => {
        //Armo la data
        const data = {
            ...accused,
            persona: {
                ...accused.persona,
                tipo_documento: accused.persona.tipoDocumento,
                nro_documento: accused.persona.identificacion
            },
            defensoria: values.defensoria && values.defensoria !== '' ? {
                id: values.defensoria
            } : null,
            menor: values.menor,
            menores: values.menores && values.menores !== '' ? {
                id: values.menores
            } : null,
            particular: particulars
        }
        //Llamo al dispatch
        dispatch( updateAccusedAction(accused, data, handleClose) );
    }
    //Eliminar abogado particular
    const handleRemoveLawyer = selected => {
        //Seteo sin el abogado eliminado
        setParticulars(
            particulars.filter( p => p.index !== selected.index )
        );
    }
    //Esquema de validación
    const validationSchema = yup.object({
        menor: yup.number().required()
    });
    //Renderizo
    return (
        <Modal
            show={show} 
            onHide={handleClose} 
            onShow={handleOnShow} 
            aria-labelledby="contained-modal-title-vcenter" 
            centered
            size="lg"
        >
            {
                hide ? (
                    <div className="custom-backdrop-modal"></div>
                ) : null
            }
            <Modal.Header closeButton>
                <Modal.Title>
                    Editar Defensa Imputado <small>(Audiencia #{ audience.id })</small>
                </Modal.Title>
            </Modal.Header>
            <Formik
                enableReinitialize
                validationSchema={validationSchema}
                initialValues={{ ...initialData }}
                onSubmit={ values => handleSave(values) }
            >
                {({
                    handleSubmit,
                    handleChange,
                    handleBlur,
                    values,
                    touched,
                    isValid,
                    errors,
                    isSubmitting
                }) => (
                    <form noValidate onSubmit={handleSubmit} autoComplete="off">
                        <Modal.Body>
                            <div className="row">
                                <div className="col-12 mt-2">
                                    <div className="alert alert-info">
                                        Seleccione si el IMPUTADO es <strong>MENOR</strong> o no. En caso de que lo sea podrá seleccionar la <strong>DEFENSORÍA DE MENORES</strong> que participa.
                                    </div>
                                </div>
                                <Form.Group className="col-md-3">
                                    <Form.Control
                                        as="select"
                                        id="menor"
                                        className="form-control"  
                                        name="menor"  
                                        value={ values.menor }
                                        onChange={handleChange}
                                        isInvalid={!!errors.menor}
                                        disabled={ loading }
                                        ref={refMenor}
                                    >
                                        <option value="0">NO</option>
                                        <option value="1">SI</option>
                                    </Form.Control>
                                    <Form.Control.Feedback type="invalid">
                                        { errors.menor }
                                    </Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group className="col-md-9">
                                    <Form.Control
                                        as="select"
                                        id="menores"
                                        className="form-control"  
                                        name="menores"  
                                        value={ values.menor == '0' ? '' : values.menores }
                                        onChange={handleChange}
                                        isInvalid={!!errors.menores}
                                        disabled={ loading || values.menor == '0' }
                                    >
                                        <option value="">Seleccione Defensoría de Menores</option>
                                        {
                                            minors ? (
                                                minors.map(minor => (
                                                    <option value={minor.id} key={`afm${minor.id}`}>
                                                        { minor.descripcion }
                                                    </option>
                                                ))
                                            ) : null
                                        }
                                    </Form.Control>
                                    <Form.Control.Feedback type="invalid">
                                        { errors.menores }
                                    </Form.Control.Feedback>
                                </Form.Group>
                                <div className="col-12 mt-2">
                                    <div className="alert alert-info">
                                        A cotinuación podrá seleccionar la <strong>DEFENSA TÉCNICA</strong> del IMPUTADO. Seleccione si actúa algún equipo operativo del MPD y/o el/los abogado/s correspondientes.
                                    </div>
                                </div>
                                <Form.Group className="col-md-7">
                                    <Form.Control
                                        as="select"
                                        id="defensoria"
                                        className="form-control"  
                                        name="defensoria"  
                                        value={ values.defensoria }
                                        onChange={handleChange}
                                        isInvalid={!!errors.defensoria}
                                        disabled={ loading }
                                    >
                                        <option value="">Seleccione el Equipo del MPD</option>
                                        {
                                            defensories ? (
                                                defensories.map(defensory => (
                                                    <option value={defensory.id} key={`afd${defensory.id}`}>
                                                        { defensory.descripcion }
                                                    </option>
                                                ))
                                            ) : null
                                        }
                                    </Form.Control>
                                    <Form.Control.Feedback type="invalid">
                                        { errors.defensoria }
                                    </Form.Control.Feedback>
                                </Form.Group>
                                <div className="col-md-5 form-group">
                                    <Button variant="primary" className="float-right" onClick={() => setShowLawyer(true)} block>
                                        <ICON_SEARCH /> BUSCAR ABOGADO PARTICULAR
                                    </Button>

                                    <LawyerSearchForm
                                        show={showLawyer}
                                        handleClose={() => {setShowLawyer(false); setHide(false)}}
                                        particulars={particulars}
                                        setParticulars={setParticulars}
                                        hideModal={setHide}
                                    />
                                </div>
                                <div className="col-12">
                                    {
                                        particulars && particulars.length > 0 ? (
                                            <table className="table table-sm">
                                                <thead className="thead-light">
                                                    <tr>
                                                        <th colSpan="4">Abogados particulares</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {
                                                        particulars.map(particular => (
                                                            <tr key={`afafp${particular.id}`}>
                                                                <td className="align-middle">
                                                                    { particular.persona.apellido + ', ' + particular.persona.nombre }
                                                                </td>
                                                                <td className="align-middle text-center">
                                                                    { particular.email }
                                                                </td>
                                                                <td className="align-middle text-center">
                                                                    { particular.telefono }
                                                                </td>
                                                                <td className="align-middle text-center">
                                                                    <Button variant="danger" size="sm" onClick={() => handleRemoveLawyer(particular)}>
                                                                        <ICON_REMOVE />
                                                                    </Button>
                                                                </td>
                                                            </tr>
                                                        ))
                                                    }
                                                </tbody>
                                            </table>
                                        ) : null
                                    }
                                </div>


                                
                            </div>
                        </Modal.Body>
                        <Modal.Footer>
                            {
                                loading ? (
                                    <ButtonSpinner />
                                ) : (
                                    <Button variant="success" type="submit" disabled={ loading }>
                                        <ICON_SAVE /> <strong>ACTUALIZAR</strong>
                                    </Button>
                                )
                            }
                            <Button variant="secondary" onClick={handleClose} disabled={ loading }>
                                <ICON_CANCEL /> Cancelar
                            </Button>
                        </Modal.Footer>
                    </form>
                )}
            </Formik>
        </Modal>
    );
};

export default AccusedDefenseEditForm;